export function userHasPermission(rules, action) {
  if (!rules) {
    return false
  }
  return !!rules.find((rule) => rule === action)
}
